<script setup lang="ts">
import EntriesListTitleInfoDialog from '@/components/entries/dialogs/EntriesListTitleInfoDialog.vue'
import InfoIcon from '@/components/icons/InfoIcon.vue'
import { useDialog } from '@/core/composables/useDialog'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

type EntryModule = 'incomes' | 'expenses' | 'bank-transactions'

interface Props {
  /** The entry module type */
  entryModule: EntryModule
  /** HTML tag to use for the title */
  tag?: string
}

const { tag = 'h2', entryModule } = defineProps<Props>()

defineOptions({
  name: 'EntriesListTitle'
})

const store = useStore()
const isTlpService = computed<boolean>(() => store.getters['app/isTlpService'])

const { t } = useI18n()
const { showDialog } = useDialog()

const openInfoDialog = (): void => {
  showDialog({
    component: EntriesListTitleInfoDialog,
    props: {
      entryModule
    }
  })
}
</script>

<template>
  <div class="flex flex-row items-center gap-2">
    <component :is="tag" class="heading-2">
      {{
        isTlpService && entryModule === 'incomes'
          ? t(`routes.invoices`)
          : t(`routes.${entryModule}`)
      }}
    </component>
    <InfoIcon class="text-primary" @click="openInfoDialog" />
  </div>
</template>
